var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vue-editor-js"}},[_c('div',{attrs:{"id":_vm.props.holderId}}),_c('button',{staticStyle:{"display":"none"},attrs:{"id":((_vm.props.holderId) + "-button")},on:{"click":_vm.save}})])}
var staticRenderFns = []

export { render, staticRenderFns }